import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Layout from './hocs/Layout';
import getRoutes from './routes';
import AnnounceKit from 'announcekit-react';

const WIDGET_URL = process.env.REACT_APP_ANNOUNCEMENTS_FLOAT_WIDGET;

class App extends Component {
    render() {
        const availableRoles = this.props.availableRoles;
        const availableRoutes = getRoutes(availableRoles, this.props.retailerId);
        return (
            <BrowserRouter>
                <Layout traderName={this.props.traderName} availableRoutes={availableRoutes} logout={this.props.logout}>
                    <Switch>
                        {availableRoutes.map(({ path, component }) => (
                            <Route exact path={path} component={component} key={path} />
                        ))}
                        <Redirect from="/" to={availableRoutes[0].path} />
                    </Switch>
                    <AnnounceKit widget={WIDGET_URL} floatWidget={true} />
                </Layout>
            </BrowserRouter>
        );
    }
}

export default App;
